import { useCallback, useState } from "react";
import { useStore } from "../../../../stores";
import clsx from "clsx";
import ItemModal from "../../../board/components/ItemModal";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

const CreateTask = ({ disabled, className }: any) => {
  const { t } = useTranslation();
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
  const { activeLiveChatCards } = useStore("bots");
  const { selectedChat } = useStore("chats");
  const { setBoardMode, findBoardByLivecardId } = useStore("boards");
  const [loadingTicket, setLoadingTicket] = useState(false);
  const firstLiveCard = activeLiveChatCards?.[0]?.id;

  const loadTicketConfig = useCallback(async () => {
    if (!firstLiveCard) {
      return;
    }
    setLoadingTicket(true);
    setBoardMode("ticket");
    try {
      await findBoardByLivecardId(String(firstLiveCard));
      setLoadingTicket(false);
      setIsTaskModalOpen(true);
    } catch (error) {
      setLoadingTicket(false);
    }
  }, [firstLiveCard, setBoardMode, findBoardByLivecardId]);

  if (!selectedChat) return null;

  return (
    <>
      <button
        onClick={loadTicketConfig}
        className={clsx(
          className ?? "button is-ghost is-no-box-shadow has-text-primary",
          {
            "is-loading": loadingTicket,
          }
        )}
        disabled={disabled || loadingTicket}
      >
        <span className="icon">
          <img src="/assets/tasks.svg" alt="" />
        </span>
        {className && <span>{t("addTask")}</span>}
      </button>
      {isTaskModalOpen && (
        <ItemModal
          defaultOpen
          onClose={() => setIsTaskModalOpen(false)}
          allowLivecardToFetchBoard
          item={
            {
              subscriberId: selectedChat.id,
              subscriber: {
                id: selectedChat.id,
                firstName: selectedChat.firstName,
                lastName: selectedChat.lastName,
                channel: selectedChat.channel,
              },
              livecardId: firstLiveCard,
            } as any
          }
        />
      )}
    </>
  );
};

export default observer(CreateTask);
